<template>
  <div style="clear: both">
    <v-card color="black">
      <v-card-title>
        <v-list-item>
          <template v-slot:prepend>
            <v-avatar color="grey">
              <v-img class="elevation-6" :src="userImageSrc"></v-img>
            </v-avatar>
          </template>
          <v-list-item-title
            class="text-h5 text-white"
            v-if="user.displayName != null"
            v-text="user.displayName"
          ></v-list-item-title>
          <v-list-item-subtitle
            class="small text-white"
            v-if="user.displayName != null"
            v-text="user.jobTitle"
          ></v-list-item-subtitle>
        </v-list-item>
      </v-card-title>
      <v-list>
        <v-list-item
          v-for="phone in user.businessPhones"
          :key="phone"
          :href="getPhone(phone)"
          prepend-icon="mdi-phone"
          :title="phone"
        >
        </v-list-item>
        <v-list-item
          v-if="user.mobilePhone != null"
          @href="getPhone(user.mobilePhone)"
          prepend-icon="mdi-phone"
          :title="user.mobilePhone"
        >
        </v-list-item>
        <v-list-item v-if="user.mail != null" @href="getEmail(user.mail)" prepend-icon="mdi-mail" :title="user.mail">
        </v-list-item>
        <v-list-item v-if="user.officeLocation != null" prepend-icon="mdi-map-marker-outline" :title="user.officeLocation">
        </v-list-item>

        <v-card-actions v-if="showCloseBtn">
          <v-spacer></v-spacer>
          <v-btn @click="closeCard()" text>{{ $t('Close') }}</v-btn>
        </v-card-actions>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import MSGraphService from '@/services/msgraph.service'
export default {
  data() {
    return {
      userImageSrc: ''
    }
  },
  props: {
    user: {},
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async getUserImageUrl(user) {
      // set temp image in case user has none
      MSGraphService.getInitialsImageUrl(user).then((r) => {
        this.userImageSrc = r
      })
      MSGraphService.getUserImageUrl(user)
        .then((r) => {
          this.userImageSrc = r
        })
        .catch((e) => {
          e
        })
    },
    getEmail: function (mail) {
      return 'mailto:' + mail
    },
    getPhone: function (phone) {
      return 'tel:' + phone.replace(/\s/g, '')
    },
    getSms: function (phone) {
      return 'sms:' + phone.replace(/\s/g, '')
    },
    closeCard: function () {
      this.$emit('closeDetails')
    }
  },
  computed: {},
  beforeMount: function () {
    this.getUserImageUrl(this.user)
  }
}
</script>

<style scoped>
.v-list-item-title {
  line-height: 2rem !important;
}
</style>
